const messages = {
  $accounting: {
    packages: {
      monthly_expenses1: "Revenue per year",
      plan_details: {
        estimated:
          "If you're not too sure, no worries - just select the lowest tier to get started. ",
        selected_estimate: "Selected your estimated revenue per year",
      },
    },
  },
  $public_onboarding: {
    accounting: {
      total_average_monthly_business_expenditure:
        "What is your average annual business revenue?",
    },
    checkout_values: {
      monthly_expense: "revenue per year",
      invalid_package_title: "Please select a valid package before saving",
      no_billing_available: "No monthly billing available",
    },
    copy: {
      satisfaction_guaranteed_subtext:
        "We will refund the fees engaged within the first 28 days, should you be unhappy with our service.",
      satisfaction_guaranteed_subtext_with_sleek:
        "We will refund the fees engaged within the first 28 days, should you be unhappy with our service.",
    },
    cart_summary_accounting: {
      accounting_tax:
        "Accounting Plan - Accounting Starter </br> ({price} annual revenue)",
      accounting_annual_filling:
        "Annual Bookkeeping - up to {price} Monthly expenses",
      accounting_payroll:
        "Accounting & Payroll - up to {price} Monthly expenses",
      accounting_premium: "Accounting Premium - up to {price} Monthly expenses",
      above_value: "Accounting - Above {price} Monthly expenses",
      accounting_tax_return_only:
        "Tax and return only - {price} annual revenue",
      accounting_tax_payroll: "Acounting Pro - {price} annual revenue",
      sole_trader_tax_accounting:
        "Sole Trader Tax & Accounting - {price} annual revenue",
      sole_trader_tax_return: "Sole Trader Tax Return - {price} annual revenue",
      tax_return_only: "Tax and return only - {price} annual revenue",
    },
    label_included: "Free",
    remediation: {
      whats_included_text: "What's included",
      card_title: "Accounting & Tax Remediation",
      card_description:
        "Up to <strong>100 transactions</strong> for each past financial year",
      package_side_label: "Remediation FY{number}",
      package_side_label_exceed_amount_remediation_years:
        "Remediation prior to FY{number}",
      description_for_option_exceed_default_year:
        "Accounting & Tax Remediation - Beyond {number} past FYs",
    },
  },
};

export default messages;
